import React, { FunctionComponent, useEffect, useState } from 'react';
import { getLocale } from 'umi';
import { setLocaleState } from "@home/utils/state";
import { setIframeLocale } from "@home/utils/lang";
import { SYSTEM_THEME_DARK_CLASS } from "@home/_config/config";
import DatalabToReportCommunicator from "@/pages/datalab/pages/IframePage/DatalabToReportCommunicator";
import {
  DatalabPostMessageType,
  TDatalabCommunicatorData, TThemeInfo
} from "@/pages/datalab/pages/IframePage/types";
import { changeTheme } from "@/pages/datalab/pages/IframePage/until";
import './index.scss';

const IframePage: FunctionComponent  = (props: any) => {
  
  const [messageData, setMessageData] = useState<TDatalabCommunicatorData>({});
  
  useEffect(() => {
    // 1. 构建通信单例类实例, 构建时已注册message事件监听
    const datalabMessageBus = DatalabToReportCommunicator.getInstance();
    // 2. 设置接收到承接页面初始化数据后的处理方式
    datalabMessageBus.addMessageHandler(DatalabPostMessageType.InitData, (payload: TDatalabCommunicatorData) => {
      // 传递了language, 且和iframe页面语言不一致, 执行切换语言
      if (payload?.language && (payload.language !== getLocale())) {
        setIframeLocale(payload.language);
      }
      // 跟随父页面主题
      payload?.theme && changeTheme(payload.theme);
      
      datalabMessageBus.saveDatalabCommunicatorData(payload);
      
      const {gameCode, dashboardId, dashboardName, paramsOfIframe, system, attributes} = payload || {};
      // const { exportPageId, gameName, reportPageId, typeId} = paramsOfIframe || {}
      // messageData是传递给 CommonDashboardReport参数的, 其他没有使用iframe的承接页面也是用的CommonDashboardReport, 统一传递的参数
      setMessageData({dashboardName, dashboardId, gameCode, system, attributes, reportInfo: {
        uid: gameCode,
        pageName: dashboardName,
        ...paramsOfIframe,
      }});
    });
    
    // 3. 设置接收到刷新token消息的处理方式
    datalabMessageBus.addMessageHandler(DatalabPostMessageType.UpdateToken, datalabMessageBus.handleTokenUpdate.bind(datalabMessageBus));
    
    // 4. 设置接收中英文转换的处理方式
    datalabMessageBus.addMessageHandler(DatalabPostMessageType.ChangeLanguage, (payload: {language: 'string';}) => {
      // en-US 是英文, zh-CN 是中文
      setIframeLocale(payload?.language, false);
    });
    
    // 5. 设置接收主题切换的处理方式
    datalabMessageBus.addMessageHandler(DatalabPostMessageType.ChangeTheme, (payload: {theme: TThemeInfo;}) => {
      payload?.theme && changeTheme(payload.theme);
    });
    
    // 6. 通知承接页面 iframe页面已加载完成
    datalabMessageBus.notifyComponentMounted();
    // 7. 保存在全局变量里
    setLocaleState('datalabMessageBus', datalabMessageBus);
    
    // 父页面的主题是Dark需要把 iframe内部的body上的c-theme-dark class删除, 然后增加Datalab iframe专用的类名
    document.body.classList.remove(SYSTEM_THEME_DARK_CLASS);
    
    // 由于嵌入到iframe时, 出现底部滚动条, 所以要重新设置原本的minWidth.
    const rootElement = document.querySelector('#root');
    rootElement && (rootElement.className = 'datalab-iframe');
    document.documentElement.style.minWidth = '100%';
    document.body.style.minWidth = '100%';
    
    return () => {
      // 删除全局变量配置
      setLocaleState('datalabMessageBus', undefined);
      // 销毁单例实例, 和其他
      DatalabToReportCommunicator.destroyInstance();
    };
  }, []);
  
  return React.cloneElement(props.children, {...messageData});
};

export default IframePage;